// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uxp-empty-widget-template{position:relative}.uxp-empty-widget-template .container{width:100%;height:100%;margin:0;padding:0;border:0;position:relative;padding-top:60px;border-radius:inherit}.uxp-empty-widget-template .container .header{position:absolute;top:0;left:0;height:60px;width:100%}.uxp-empty-widget-template .container .body{width:100%;height:100%;overflow-y:auto;padding:20px}", ""]);
// Exports
module.exports = exports;
